<template>
  <div class="login-wrap flex-box flex-column space-center">
    <div class="login-box flex-box flex-column">
      <div class="icon-box">
        <div class="flex-box space-center">
            <img src="../../assets/logo.png" class="logo" />
            <span class="logo-text">{{$t('中国人成骨不全症变异数据库（COIMD）')}}</span>
          </div>
        <div class="close-icon" @click="goBack"></div>
      </div>
      <div class="login-content flex-box flex-column">
        <div class="title flex-box">
          <span>账号密码登录</span>
        </div>
        <p class="text email-text">{{$t('邮箱')}}</p>
        <el-input
          placeholder="请输入"
          v-model="user"
          clearable>
        </el-input>
        <p class="text pwd-text">{{$t('密码')}}</p>
        <el-input
          placeholder="请输入"
          v-model="pwd"
          type="password"
          :class="isErr && 'is-error'"
          show-password>
        </el-input>
        <div class="flex-box space-between tip">
          <div class="error-text flex-box">
            <p class="flex-box" v-if="isErr">
              <span class="error-icon"></span>
              账号密码输入错误
            </p>
          </div>
          <p class="reset-pwd" @click="resetPwd">忘记密码?</p>
        </div>
        <div class="flex-box agree-box">
          <el-checkbox v-model="checked"></el-checkbox>
          <span class="checkbox-label">我已阅读并同意<router-link tag="a" target="_blank" to="/disclaimer" class="protocol-text">免责声明</router-link> 和 <router-link tag="a" target="_blank" to="/policy" class="protocol-text">隐私政策</router-link></span>
        </div>
        <div class="btn-box flex-box">
          <div class="btn login-btn flex-1" @click="login">{{$t('登录')}}</div>
          <div class="btn sigin-btn flex-1" @click="sigin">{{$t('注册')}}</div>
        </div>
        <p class="tip-text">
          请确保安全的情况下输入密码
        </p>
      </div>
    </div>
  </div>
</template>

<script>

import {login} from '../../request/api'

export default {
  name: '',

  data () {
    return {
      user: '',
      pwd: '',
      isErr: false,
      checked: false
    }
  },

  methods: {
    goBack () {
      this.$router.push({path: '/'})
    },
    sigin () {
      this.$router.push('/sigin')
    },
    login () {
      if (this.user == '') {
        this.$message.error('邮箱不能为空')
        return
      }
      if (this.pwd == '') {
        this.$message.error('请输入密码')
        return
      }
      if (!this.checked) {
        this.$alert('请先同意 服务协议 和 隐私政策', '提示', {
          confirmButtonText: '确定',
          showClose: false
        })
        return
      }
      login({email: this.user, password: this.pwd}).then( res => {
        if (res.token) {
          localStorage.setItem('token', res.token)
          localStorage.setItem('isLogin', 1)
          localStorage.setItem('webOIUser', res.username)
          this.$message.success('登录成功')
          this.$router.push('/')
        }
      }).catch(err => {
        // 模拟登录
          // localStorage.setItem('token', '61ab0784-85e6-47f4-bbd5-b5e72b342fa2')
          // localStorage.setItem('isLogin', 1)
          // localStorage.setItem('user', 'qq达人')
          // this.$message.success('登录成功')
          // this.$router.push('/')
          // console.log(err)
        this.$message.error(err)
      })
    },
    resetPwd () {
      if (this.user == '') {
        this.$message.error('请输入邮箱')
        return
      } 
      this.$router.push({
        path: '/send_code',
        query: {
          email: this.user
        }
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.login-wrap {
  height: 100vh;
  background: rgba(0,0,0,.8);
  .login-box {
    width: 400px;
    .icon-box {
      width: 100%;
      height: 43px;
      position: relative;
      .logo {
      height: 40px;
      margin-right: 12px;
      display: inherit;
      border-radius: 50%;
    }
    .logo-text {
      font-size: 24px;
      font-weight: 500;
      color: #fff;
    }
      .close-icon {
        width: 40px;
        height: 40px;
        background: url('../../assets/icon/close-icon.png');
        background-size: 100% 100%;
        position: absolute;
        right: -103px;
        top: 0;
        cursor: pointer;
      }
    }
    .login-content {
      height: 420px;
      background: #fff;
      border-radius: 10px;
      width: 100%;
      margin-top: 28px;
      padding-top: 34px;
      padding-left: 40px;
      padding-right: 40px;
      box-sizing: border-box;
      .title {
        color: #333333;
        font-size: 19px;
        font-weight: bold;
        .suo-icon {
          width: 30px;
          height: 30px;
          margin-right: 5px;
        }
      }
      .text {
        color: #333333;
        font-weight: bold;
        width: 100%;
        &.email-text {
          margin-top: 45px;
          margin-bottom: 10px;
        }
        &.pwd-text {
          margin-top: 16px;
          margin-bottom: 10px;
        }
      }
      .tip {
        width: 100%;
        margin-top: 6px;
        font-size: 14px;
      }
      .error-text {
        color: #FF4444;
      }
      .error-icon {
        width: 18px;
        height: 18px;
        background: url('../../assets/icon/error-icon.png');
        background-size: 100% 100%;
        margin-right: 8px;
      }
      .reset-pwd {
        color: #4EABF9;
        cursor: pointer;
      }
      .btn-box {
        margin-top: 14px;
        width: 100%;
        .btn {
          border-radius: 4px;
          height: 38px;
          color: #fff;
          font-size: 16px;
          text-align: center;
          line-height: 38px;
          cursor: pointer;
          &:hover {
            opacity: .9;
          }
          &.login-btn {
            margin-right: 20px;
            background: #304870;
          }
          &.sigin-btn {
            background: #4EABF9;
          }
        }
      }
      .agree-box {
        width: 100%;
        margin-top: 8px;
        font-size: 12px;
      }
      .checkbox-label {
        margin-left: 4px;
        color: #333;
      }
      .protocol-text {
        margin-left: 4px;
        color: #4EABF9;
        cursor: pointer;
        text-decoration: none;
      }
      
      .tip-text {
        margin-top: 14px;
        color: #666666;
        font-size: 14px;
      }
    }
  }
}
</style>
